import { slugify } from 'transliteration'
import store from '@/store'

export default {
  data: () => ({
    flattenCats: [],
    slugs: null,
    isFollowedPublications: false,
    isUserPublications: false,
    queryParams: []
  }),

  methods: {
    slugify,

    /**
     * Returns url using state parameters.
     *
     * @param {string} id
     * @return {string}
     */
    createUrl (id) {
      const pathArray = this.getPathArray(this.flattenCats, id)

      return `/${pathArray.join('/')}`
    },

    slugifyCats: cats => cats.map(cat => ({ ...cat, slug: slugify(cat.name) })),

    recursiveSlugifyCats (cats) {
      const slugifyCat = cat => {
        if (cat.childs) cat.childs = cat.childs.map(slugifyCat)
        cat.slug = slugify(cat.name)
        // cat.action = this.createUrl(cat.id)
        cat.action = `/${slugify(cat.name)}`
        return cat
      }

      return cats.map(slugifyCat)
    },

    findCatBySlug: cats => slug => cats.find(cat => cat.slug === slug),

    /**
     * (deprecated) Searches and array tree categories and return the target cat id.
     *
     * @param {Array} this.cats
     * @param {string} this.slug1
     * @param {string} this.slug2
     * @param {string} this.slug3
     * @return {string} target id.
     */
    getCatId () {
      let filteredCat

      if (this.slug1) {
        filteredCat = this.findCatBySlug(this.slugifyCats(this.cats))(this.slug1)
        if (!filteredCat) return null
      }

      if (this.slug2) {
        filteredCat = this.findCatBySlug(this.slugifyCats(filteredCat.childs))(this.slug2)
        if (!filteredCat) return null
      }

      if (this.slug3) {
        filteredCat = this.findCatBySlug(this.slugifyCats(filteredCat.childs))(this.slug3)
        if (!filteredCat) return null
      }

      return filteredCat.id
    },

    // sin uso
    slugifyCategories () {
      const slugifyCat = cat => ({
        id: cat.id,
        slug: slugify(cat.name)
      })

      const flattenCats = cats => cats.flatMap(cat => cat.childs
        ? [slugifyCat(cat), ...flattenCats(cat.childs)]
        : [slugifyCat(cat)])

      return flattenCats(this.cats)
    },

    /**
     * flattens and adds slug and parent to categories.
     *
     * @param {Array} cats array tree.
     * @return {Array[Object]} fatten.
     */
    slugParentFlattenCategories: (cats) => {
      const slugParentCat = (cat, parent) => ({
        id: cat.id,
        name: cat.name,
        slug: slugify(cat.name),
        parent
      })

      const flattenCats = (cats, parent) => cats.flatMap(cat => cat.childs
        ? [slugParentCat(cat, parent), ...flattenCats(cat.childs, cat.id)]
        : [slugParentCat(cat, parent)])

      return flattenCats(cats, null)
    },

    /**
     * Returns an array of slug from oldest to target.
     *
     * @param {Array} cats
     * @param {string} id
     * @return {Array[string:slug]}
     */
    getPathArray: (cats, id) => {
      const path = []

      const matcher = cats => id => {
        const cat = cats.find(cat => cat.id === id)
        if (cat.slug) path.unshift(cat.slug)
        // if (cat.parent) matcher(cats)(cat.parent)
      }

      matcher(cats)(id)

      return path
    },

    /**
     * Returns a promise, which is resolved if the URL in route has valid lat, lon & city parameters.
     * Promise is rejected otherwise.
     *
     * @param {Object} route
     * @return {Promise}
     */
    parseRoute (route) {
      return new Promise((resolve, reject) => {
        const query = route.query

        // checking if in followed user publications
        this.isFollowedPublications = route.name === 'userFollowedUserPublications'
        // checking if in user's publications
        this.isUserPublications = route.name === 'userPublications'

        const queryLat = parseFloat(query.lat)
        const queryLon = parseFloat(query.lon)
        const queryCity = query.city
        const routeLocationComplete = !!queryLat && !!queryLon && !!queryCity

        // If lat, lon & city are present in the URL, parse it. Otherwise, reject the returned promise
        if (routeLocationComplete || this.isUserPublications) {
          const location = {
            lat: queryLat,
            lon: queryLon,
            city: queryCity
          }
          const queryDistance = parseInt(query.distance)
          const distance = !!queryDistance || queryDistance === 0 ? queryDistance : -1

          // Searches for the query that starts with 'category', so it's independent from the label displayed 'Categorías'
          const catQuery = Object.keys(query).filter(q => q.startsWith('category'))
          if (catQuery.length > 0) {
            const cat = catQuery[0]
            this.catId = query[cat].split('_').length > 1 ? query[cat].split('_')[1] : null
          } else {
            this.catId = null
          }

          this.queryParams = Array.from(Object.entries(query))
            .map(([key, val]) => ({ key, val }))

          const simples = this.queryParams
            .filter(({key}) => !['catId', 'lat', 'lon', 'distance', 'city', 'page'].includes(key))

          const min = simples.filter(s => s.key === 'min_Precio mínimo')
          const max = simples.filter(s => s.key === 'max_Precio máximo')
          const price = {
            min: min.length > 0 && min[0].val.split('_')[0],
            max: max.length > 0 && max[0].val.split('_')[0]
          }

          const page = query.page
          const q = query.q

          if (page && !this.isUserPublications) store.dispatch('category/setPage', page)
          else if (page && this.isUserPublications) store.dispatch('user/setPage', page)

          if (distance !== this.currentDistance) store.dispatch('setDistance', distance)
          store.dispatch('filters/setLocation', location)
          store.dispatch('filters/setPrice', price)
          store.dispatch('filters/setSimples', simples)
          if (q) store.dispatch('setSearchQuery', q)
          resolve()
        } else {
          reject()
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/categories.js